import { useAuthStore } from '@/stores/authStore';

const API_URL = import.meta.env.VITE_API_URL || '';

// CSVダウンロード
export async function downloadCSV(endpoint: string, filename?: string) {
  const token = useAuthStore.getState().accessToken;
  
  const response = await fetch(`${API_URL}${endpoint}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('ダウンロードに失敗しました');
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  
  // Content-Dispositionからファイル名を取得
  const contentDisposition = response.headers.get('Content-Disposition');
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) {
      a.download = match[1];
    }
  }
  
  if (filename) {
    a.download = filename;
  }
  
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

// CSVファイルを読み込んでテキストとして返す
export function readCSVFile(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target?.result as string;
      resolve(text);
    };
    reader.onerror = () => reject(new Error('ファイルの読み込みに失敗しました'));
    reader.readAsText(file, 'UTF-8');
  });
}

// CSVインポート
export async function importCSV(endpoint: string, csvText: string) {
  const token = useAuthStore.getState().accessToken;
  
  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ csv: csvText }),
  });

  if (!response.ok) {
    throw new Error('インポートに失敗しました');
  }

  return response.json();
}


